import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReduxBlockUi from 'react-block-ui/redux';
import { Panel, Tabs, Tab } from 'react-bootstrap';
import {
	fetchDiscount, createDiscount, updateDiscount,
	DISCOUNT_CREATE_REQUEST, DISCOUNT_CREATE_SUCCESS, DISCOUNT_CREATE_FAILURE,
	DISCOUNT_UPDATE_REQUEST, DISCOUNT_UPDATE_SUCCESS, DISCOUNT_UPDATE_FAILURE
} from './actions';
import DiscountSettingsForm, { selector as discountSettingsFormSelector, initializeForm as initializeDiscountSettingsForm } from './SettingsForm';
import authUtils from '../../auth/utils';
import { loadUnpagedGrades } from '../grades/actions';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import { withTranslation } from 'react-i18next';
import BackButton from '../../common/components/BackButton';
import Usage from './usage';

const promoCodeCharacters = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';// abcdefghjkmnpqrstuvwxyz

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleDiscountSettingsSubmit = this.handleDiscountSettingsSubmit.bind(this);
		this.handlePromoCodeGenerate = this.handlePromoCodeGenerate.bind(this);
		this.handleTabSelect = this.handleTabSelect.bind(this);
	}

	componentDidMount() {
		const { match, fetchDiscount } = this.props;
		const discountId = match.params.id;

		this.loadGrades();

		if (discountId) {
			fetchDiscount(discountId);
		}
	}

	handleDiscountSettingsSubmit(values) {
		const { discount, createDiscount, updateDiscount, history } = this.props;

		let newValues = { ...values };

		if (newValues["usageType"]) {
			newValues["usageType"] = newValues["usageType"]
				.map(entry => entry.value)
				.reduce((accumulator, currentValue) => accumulator | currentValue);
		}

		if (discount) {
			updateDiscount(discount.id, newValues);
		} else {
			createDiscount(newValues, history);
		}
	}

	handlePromoCodeGenerate() {
		const charSetLength = promoCodeCharacters.length;
		const promoCodeLength = 7;
		let promoCode = '';
		for (let i = 0; i < promoCodeLength; i++) {
			promoCode += promoCodeCharacters[Math.floor(Math.random() * charSetLength)];
		}

		return promoCode;
	}

	handleTabSelect(key) {
		const { discount } = this.props;
		if (discount) {
			this.props.history.replace(`/discounts/${discount.id}/${key}`);
		}
	}

	loadGrades() {
		this.props.loadUnpagedGrades();
	}

	prepareUsageTypes(discountUsageTypes) {
		if (!discountUsageTypes) {
			return [];
		}

		return Object.keys(discountUsageTypes)
			.map(id => {
				const entry = discountUsageTypes[id];
				return { value: entry.id, label: entry.displayName };
			});
	}

	render() {
		const { match, discount, isReadonly, isCenterRequired, gradesList, discountTypes, discountFormValues, discountUsageTypes,
			offerIndividualConsultations, offerWorkshops, t } = this.props;
		const defaultValues = { unlimitedUsage: true, unlimitedUsagePerParent: true, isPercentage: true, usedAmount: 0 };
		const usageTypes = this.prepareUsageTypes(discountUsageTypes);

		let initialValues = { ...defaultValues }
		if (discount) {
			initialValues = { ...initialValues, ...discount };
			initialValues.usageType = this.prepareUsageTypes(discount.usageType);
		}
		else {
			const defaultUsageType = discountUsageTypes && discountUsageTypes.filter(item => item.id === 1);
			initialValues.usageType = this.prepareUsageTypes(defaultUsageType);
		}

		const selectedTab = match.params.tab || 'details';

		return <React.Fragment>
			<BackButton style={{ marginBottom: '10px' }}>{t('Common_BackToList')}</BackButton>
			<Tabs defaultActiveKey={selectedTab} onSelect={this.handleTabSelect}>
				<Tab eventKey='details' title={t('Discount_Details')}>
					<Panel>
						<Panel.Heading>{t('Common_Details')}</Panel.Heading>
						<Panel.Body>
							<ReduxBlockUi block={[DISCOUNT_CREATE_REQUEST, DISCOUNT_UPDATE_REQUEST]}
								unblock={[DISCOUNT_CREATE_SUCCESS, DISCOUNT_UPDATE_SUCCESS, DISCOUNT_CREATE_FAILURE, DISCOUNT_UPDATE_FAILURE]}>
								<DiscountSettingsForm isReadonly={isReadonly} onSubmit={this.handleDiscountSettingsSubmit} onGeneratePromoCode={this.handlePromoCodeGenerate} initialValues={initialValues}
									isCenterRequired={isCenterRequired} discountTypes={discountTypes} grades={gradesList} usageTypes={usageTypes}
									offerIndividualConsultations={offerIndividualConsultations} offerWorkshops={offerWorkshops} {...discountFormValues} />
							</ReduxBlockUi>
						</Panel.Body>
					</Panel>
				</Tab>
				{discount && <Tab eventKey='usage' title={t('Discount_Usage')}>
					<Usage discount={discount} />
				</Tab>}
			</Tabs>
		</React.Fragment>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const discountId = ownProps.match.params.id;

	const {
		entities: { discounts, grades },
		lookups: { discountTypes, discountUsageTypes },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const discount = discounts[discountId];

	return {
		discount: discount,
		discountTypes: discountTypes,
		isReadonly: discount && discount.isReadonly,
		isCenterRequired: currentUser.isCenterRestricted || currentUser.isFranchiseeRestricted,
		gradesList: grades,
		discountUsageTypes,
		offerIndividualConsultations: franchisor.offerIndividualConsultations,
		offerWorkshops: franchisor.offerWorkshops,
		discountFormValues: discountSettingsFormSelector(state, 'typeId', 'unlimitedUsage', 'unlimitedUsagePerParent', 'hasMinLessonCount', 'hasMaxLessonCount', 'isPercentage', 'allowPartialUse')
	};
};

export default connect(mapStateToProps, {
	fetchDiscount,
	createDiscount,
	updateDiscount,
	loadUnpagedGrades,
	initializeDiscountSettingsForm
})(withTranslation()(Details));